import { formatISO } from 'date-fns';

export const formatShortISO = (date: Date, allDay?: boolean) => {
  return formatISO(date, {
    representation: allDay ? 'date' : 'complete'
  }).replace(/[-:]/g, '');
};
